
import Vue from "vue";
import Component from "vue-class-component";
import InformationsBlock from "@/components/InformationsBlock.vue";
import NavBar from "@/components/NavBar";

@Component({
  components: {
    NavBar,
    InformationsBlock
  }
})
export default class FaqPage extends Vue {
  get faqs() {
    return this.$t("faq.faqs");
  }
}
